import { Injectable } from '@angular/core';
import {BaseService} from "@core/service/base.service";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import { Observable } from 'rxjs';
import {Subject} from "rxjs/index";
export const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
@Injectable({
  providedIn: 'root'
})
export class SourceViewSupService extends BaseService{
  private url = 'api/sourcing-enroll';
  private offerUrl = 'api/souring-normal-quote';
  private getQualStatusUrl = "api/sourcing-enroll-qual/get-login-qual-status";
  private getDepositStatusUrl = "api/sourcing-enroll-deposit/get-login-deposit-status";
  private getDepositIdUrl = "api/sourcing-enroll-deposit/get-login-deposit-id";
  private getRefundDepositUrl = "api/sourcing-refund-deposit";
  private ratingSaveAttachUrl = "api/souring-normal-quote/save-files";

  constructor(http: HttpClient) {
    super(http);
  }
  public supEnrollStatus:any;

  getUrl(): string {
    return this.url;
  }
//修改报名联系人信息
  changeContact(sourcingEnrollDto:any){
    const url = `${this.getUrl()}/change-contact`;
    return this.http.post<any>(url, sourcingEnrollDto, httpOptions).pipe(
      tap((object: any) => this.log(`changeContact`)),
      catchError(this.handleError<any>('changeContact')),
    );
  }

//  供应商参与
  applyBySup(id){
    const url = `${this.getUrl()}/apply-by-sup`;
    let params = {
      sourcingEnrollId:id
    };
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        params:params
      }
    ).pipe(
      tap(() => this.log('applyBySup')),
      catchError(this.handleError('applyBySup'))
    );
  }

//  获取供应商报名信息
  enrollBySourcingId(id){
    const url = `${this.getUrl()}/enroll-by-sourcing-id-sup`;
    let params = {
      sourcingId:id
    };
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        params:params
      }
    ).pipe(
      tap(() => this.log('enrollBySourcingId')),
      catchError(this.handleError('enrollBySourcingId'))
    );
  }

//  供应商放弃报名
  giveUpEnroll(id){
    const url = `${this.getUrl()}/give-up`;
    let params = {
      sourcingId:id
    };
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        params:params
      }
    ).pipe(
      tap(() => this.log('giveUpEnroll')),
      catchError(this.handleError('giveUpEnroll'))
    );
  }

//  供应商放弃参与
  giveUpAll(idArr: any[]):Observable<any>{
    const url = `${this.getUrl()}/give-up-batch`;
    let params = new HttpParams();
    for (let item of idArr) {
      params = params.append('id', item);
    }
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        params:params
      }
    ).pipe(
      tap(() => this.log('giveUpAll')),
      catchError(this.handleError('giveUpAll'))
    );
  }

//  供应商报价检查
  quoteCheck(params){
    const url = `${this.offerUrl}/check`;
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        params:params
      }
    ).pipe(
      tap(() => this.log('quoteCheck')),
      catchError(this.handleError('quoteCheck'))
    );
  }

//获取报价详情
  getQuoteDetail(params){
    const url = `${this.offerUrl}/round`;
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        params:params
      }
    ).pipe(
      tap(() => this.log('getQuoteDetail')),
      catchError(this.handleError('getQuoteDetail'))
    );
  }


  //获取物料详情
  selectMaterialData(params){
    const url = `${this.offerUrl}/findMaterialName`;
    return this.http.get(url,
        {
          headers: httpOptions.headers,
          params:params
        }
    ).pipe(
        tap(() => this.log('selectMaterialData')),
        catchError(this.handleError('selectMaterialData'))
    );
  }

  //获取品类详情
  selectSupplyTypeData(params){
    const url = `${this.offerUrl}/findSupplyType`;
    return this.http.get(url,
        {
          headers: httpOptions.headers,
          params:params
        }
    ).pipe(
        tap(() => this.log('selectSupplyTypeData')),
        catchError(this.handleError('selectSupplyTypeData'))
    );
  }


//  根据供应商获取报价详情
  getQuoteDetailCg(params){
    const url = `${this.offerUrl}/round-cg`;
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        params:params
      }
    ).pipe(
      tap(() => this.log('getQuoteDetail')),
      catchError(this.handleError('getQuoteDetail'))
    );
  }

//  供应商保存报价
  saveQuoteDetail(object:any){
    const url = `${this.offerUrl}/save-storage`;
    return this.http.post<any>(url, object, httpOptions).pipe(
      tap((object: any) => this.log(`saveQuoteDetail`)),
      catchError(this.handleError<any>('saveQuoteDetail')),
    );
  }

  //供应商提交报价前校验
  submitBeforeValid(object:any){
    const url = `${this.offerUrl}/valid`;
    return this.http.post<any>(url, object, httpOptions).pipe(
      tap((object: any) => this.log(`submitQuoteDetail`)),
      catchError(this.handleError<any>('submitQuoteDetail')),
    );
  }

  //  供应商提交报价
  submitQuoteDetail(object:any){
    const url = `${this.offerUrl}/commit`;
    return this.http.post<any>(url, object, httpOptions).pipe(
      tap((object: any) => this.log(`submitQuoteDetail`)),
      catchError(this.handleError<any>('submitQuoteDetail')),
    );
  }

//  判断是否为密封报价
  checkPurService(params){
    const url = `${this.offerUrl}/check-pur`;
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        params:params
      }
    ).pipe(
      tap(() => this.log('getQuoteDetail')),
      catchError(this.handleError('getQuoteDetail'))
    );
  }

// 获取供应商提交保证金是否可填写
  getLoginDepositStatus(id){
    return this.http.get(this.getDepositStatusUrl,
      {
        headers: httpOptions.headers,
        params:{
          sourcingId:id
        }
      }
    ).pipe(
      tap(() => this.log('getQuoteDetail')),
      catchError(this.handleError('getQuoteDetail'))
    );
  }

  // 获取供应商提交资质是否可填写
  getLoginQualStatus(id){
    return this.http.get(this.getQualStatusUrl,
      {
        headers: httpOptions.headers,
        params:{
          sourcingId:id
        }
      }
    ).pipe(
      tap(() => this.log('getQuoteDetail')),
      catchError(this.handleError('getQuoteDetail'))
    );
  }

//  采购查看报价
  purGetOffer(params){
    const url = `${this.offerUrl}/pur-view`;
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        params:params
      }
    ).pipe(
      tap(() => this.log('purGetOffer')),
      catchError(this.handleError('purGetOffer'))
    );
  }

//  查看报价时的的检查是否有报价
  roundCheckView(params){
    const url = `${this.offerUrl}/round-check-view`;
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        params:params
      }
    ).pipe(
      tap(() => this.log('roundCheckView')),
      catchError(this.handleError('roundCheckView'))
    );
  }

//  查看报价时的报价详情接口
  offerRoundView(params){
    const url = `${this.offerUrl}/round-view`;
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        params:params
      }
    ).pipe(
      tap(() => this.log('offerRoundView')),
      catchError(this.handleError('offerRoundView'))
    );
  }

//  发布实时竞价订阅事件
  private momentOfferEvent = new Subject<any>();
  momentOfferEvent$ = this.momentOfferEvent.asObservable();


  sendMomentOffer(message){
    this.momentOfferEvent.next(message);
  }

  /**
   * 获取清单
   * */
  getBidSeal(info): Observable<any> {
    const url = `api/sourcing/${info}`;
    return this.http.get<any>(url, {
      headers: httpOptions.headers,
    }).pipe(
      tap(_ => this.log(`getBidSeal`)),
      catchError(this.handleError<any>(`getBidSeal-log`)),
    );
  }

  //获取当前登陆供应商信息
  getSupplierId():Observable<any> {
    return this.http.get<any>('api/supplier/current-sample').pipe(
      tap(_ => this.log(`getSupplierId`)),
      catchError(this.handleError<any>(`getSupplierId`))
    );
  }

  //获取保证金id，流程id
  getLoginDepositId(id) {
    return this.http.get(this.getDepositIdUrl,
      {
        headers: httpOptions.headers,
        params:{
          sourcingId:id
        }
      }
    ).pipe(
      tap(() => this.log('getQuoteDetail')),
      catchError(this.handleError('getQuoteDetail'))
    );
  }

  findRefundDepositBySourcingAndSupplier(supplierId: any, sourcingId: any) {
    return this.http.get(this.getRefundDepositUrl+"/find-by-supplier-sourcing/"+supplierId+"/"+sourcingId).pipe(
      tap(() => this.log(`findRefundDepositBySourcingAndSupplier`)),
      catchError(this.handleError<any>(`findRefundDepositBySourcingAndSupplier`))
    );
  }

  summitRefundDepisit(reufndDeposit:any) : Observable<any>{
    return this.http.post<any>(this.getRefundDepositUrl+"/submit",reufndDeposit).pipe(
      tap(() => this.log(`submmitRefundDeposit`)),
      catchError(this.handleError<any>(`submmitRefundDeposit`))
    );
  }

//  评比/评标阶段供应商上传附件
  ratingSaveAttach(quoteDto:any) : Observable<any>{
    return this.http.post<any>(this.ratingSaveAttachUrl,quoteDto).pipe(
      tap(() => this.log(`ratingSaveAttach`)),
      catchError(this.handleError<any>(`ratingSaveAttach`))
    );
  }
}
